import { CourseLectureId } from './course-lecture-interface'
import { CourseQuizId } from './course-quiz-interface'

export enum CourseLectureAssignmentStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  NotSubmitted = 'not_submitted',
}

export type CourseUnavailabilityReason =
  | 'not_included_in_partial_access'
  | 'dripping_access_is_not_granted_yet'
  | 'mandatory_assignment_not_completed'
  | 'not_enrolled'
  | 'purchase_required'
  | null

export type CourseAvailabilityState =
  | {
      available: true
      unavailabilityReason: null
    }
  | {
      available: false
      unavailabilityReason: Exclude<CourseUnavailabilityReason, null>
    }

export interface CourseMenuLectureBase {
  id: CourseLectureId
  name: string
  available: boolean
  unavailabilityReason: CourseUnavailabilityReason
  completed: boolean
  assignment: {
    mandatory: boolean
    status: CourseLectureAssignmentStatusEnum | null
  } | null
}

export type CourseMenuLectureInterface = CourseMenuLectureBase & CourseAvailabilityState

export interface CourseQuizInterface {
  id: CourseQuizId
  available: boolean
  completed: boolean
}

export interface CourseMenuModuleBase {
  lectures: CourseMenuLectureInterface[]
  salesPage?: string
  name: string
  quiz: CourseQuizInterface | null
  isCompleted: boolean
  shouldShowQuiz: boolean
}

export type CourseMenuModuleInterface = CourseMenuModuleBase & CourseAvailabilityState
